import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import settings from "./settings";
import CustomerReducer from "./CustomerReducer";
import UserReducer from "./UserReducer";
import ProfileReducer from "./properties/ProfileReducer";
import NetReducer from "./properties/NetReducer";
import YaraghReducer from "./properties/YaraghReducer";
import RokubReducer from "./properties/RokubReducer";
import FomMastikReducer from "./properties/FomMastikReducer";
import UtilityReducer from "./properties/UtilityReducer";
import GlassReducer from "./properties/GlassReducer";
import PatternReducer from "./PatternReducer";
import ProjectReducer from "./ProjectReducer";
import SettingsReducer from "./SettingsReducer";
import FactorReducer from "./FactorReducer";
import ConstructionReducer from "./ConstructionReducer";
import DesignReducer from "./DesignReducer";
import StaticsReducer from "./StaticsReducer";
import ContractReducer from "./ContractReducer";
import NotificationReducer from "./NotificationReducer";
import AccountsReducer from "./superadmin/AccountsReducer";
import TicketingReducer from "./Ticketing/TicketingReducer";
import ShopReducer from "./properties/ShopReducer";

const index = combineReducers({
  settings: settings,
  auth: AuthReducer,
  customer: CustomerReducer,
  user: UserReducer,
  profile: ProfileReducer,
  tori: NetReducer,
  yaragh: YaraghReducer,
  rokub: RokubReducer,
  fomMastik: FomMastikReducer,
  khedmat: UtilityReducer,
  shishe: GlassReducer,
  pattern: PatternReducer,
  setting: SettingsReducer,
  project: ProjectReducer,
  factor: FactorReducer,
  construction: ConstructionReducer,
  design: DesignReducer,
  statics: StaticsReducer,
  contract: ContractReducer,
  notification:NotificationReducer,
  //superadmin
  saAccounts: AccountsReducer,
  //ticketing
  ticketing: TicketingReducer,
  //shop
  shop: ShopReducer,
});

export default (state, action) =>
  index(action.type === "AUTH_LOGOUT" ? undefined : state, action);
